exports.SUPPORTED_LOCALES = [
  "en-us",
  "fr-fr",
  "de-de",
  "es-es",
  "nl-nl",
  "en-gb",
  "it-it",
  "cs-cz",
  "pl-pl",
  "sv-se",
  "da-dk",
  "fi-fi",
  "nb-no",
  "de-at",
  "en-eu",
  "ja-jp",
  "ko-kr",
  "zh-tw",
  "zh-cn",
  "ro-ro",
  "ru-ru",
  "en-in",
  "en-sg",
  "en-au",
  "tr-tr",
  "fr-be",
  "pt-br",
  "es-la",
  "es-mx",
];
